import { lazy, Suspense, useRef, type ComponentProps } from 'react';
import { saveGuestTableToCloud } from '../community/guestTableSave';
import type { TableDefinition } from '../engine/tables/definition';

const CreatorStudioImpl = lazy(() => import('./CreatorStudioImpl'));
type CreatorStudioProps = ComponentProps<typeof CreatorStudioImpl>;

/** Keep the full creator/editor surface out of the initial arcade bundle. */
export default function CreatorStudio(props: CreatorStudioProps) {
  const savingRef = useRef(false);

  const onSave = (table: TableDefinition) => {
    if (savingRef.current) return;
    savingRef.current = true;
    void saveGuestTableToCloud(table)
      .then((saved) => {
        if (!saved) props.onSave(table);
      })
      .finally(() => {
        savingRef.current = false;
      });
  };

  return (
    <Suspense fallback={<div role="status">Loading creator…</div>}>
      <CreatorStudioImpl {...props} onSave={onSave} />
    </Suspense>
  );
}
